export const menu = [

  {
    title: "Audits",
    path: "audits",
    type: "page"
  },
  {
    title: "Contact",
    target: "contact",
    type: "anchor"
  },
  {
    title: "Blog",
    path: "blog",
    type: "page"
  },
];

export const socials = [
  {
    link: "https://twitter.com/extropy",
    icon: "fa-twitter",
  },
  {
    link: "https://www.linkedin.com/company/extropy-io-ltd/",
    icon: "fa-linkedin",
  },
  {
    link: "https://extropy-io.medium.com/",
    icon: "fa-medium",
  },
  {
    link: "https://t.me/joinchat/AAAAAE4-sCvat80zz8CntQ",
    icon: "fa-telegram",
  },
  {
    link: "https://github.com/ExtropyIO",
    icon: "fa-github",
  },
];
